
export default {
  props: {
    isPairedChannelTab: {
      type: Boolean,
      default: false
    },
    channelName: {
      type: String,
      default: ""
    },
    channel: {
      type: Object,
      default: () => {}
    },
    brandId: {
      type: Number,
      required: true
    },
    channelsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loginId: "",
      url: "",
      isDataPresent: false
    };
  },
  beforeMount() {
    this.checkIfDataIsPresent();
  },
  watch: {
    channelsList() {
      this.checkIfDataIsPresent();
    },
    deep: true
  },
  computed: {
    isDisintegrationOngoing() {
      return this.channel.state === "disintegration_ongoing";
    },
    getBtnText() {
      if (this.isPairedChannelTab) {
        if (this.channel.state === "integration_ongoing") {
          return "Integrating";
        } else if (this.isDisintegrationOngoing) {
          return "Disintegrating";
        } else {
          return "Dis-integrate";
        }
      } else {
        return "Pair";
      }
    }
  },
  methods: {
    checkIfDataIsPresent() {
      this.isDataPresent = this.channel && this.channel.userInput;
    },
    handleChannelChange() {
      this.$emit("pair-unpair-selection", {
        brandId: this.brandId,
        channelId: this.channel.id
      });
    },
    deleteChannelInfo() {
      this.$emit("delete-channel-info", {
        brandId: this.brandId,
        channelId: this.channel.id
      });
    }
  }
};
